import React from 'react';

const SearchFilter = ({ 
  searchQuery, 
  onSearchChange, 
  placeholder = "Поиск...",
  className = ""
}) => {
  return (
    <div className={`flex flex-col sm:flex-row justify-between items-stretch sm:items-center mb-2 sm:mb-3 gap-1 sm:gap-0 ${className}`}>
      <span className="text-xs sm:text-sm text-gray-700 dark:text-gray-300 font-light">Фильтр</span>
      <input
        type="text"
        placeholder={placeholder}
        className="border border-gray-300 dark:border-gray-600 rounded-xl px-3 py-2 focus:outline-none focus:border-blue-800 dark:focus:border-blue-400 w-full sm:w-48 bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100 transition-colors text-xs sm:text-base"
        value={searchQuery}
        onChange={(e) => onSearchChange(e.target.value)}
      />
    </div>
  );
};

export default SearchFilter;
